import { app } from '../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {

    $stateProvider.state('public.google-info', {
        url: '/googleInfo',
        component: 'googleInfo',
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/google-info/google-info.state.js